module.exports = __webpack_public_path__ + "static/img/index_bg.ba3ac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_bg.jpg
// module id = cq9H
// module chunks = 1